export interface OfflineState { ready:boolean; version:string; count:number }
export async function verifyOffline(worker:ServiceWorker):Promise<OfflineState>{
  return new Promise(resolve=>{
    const channel=new MessageChannel();const timeout=window.setTimeout(()=>resolve({ready:false,version:'',count:0}),8000);
    channel.port1.onmessage=(event:MessageEvent<OfflineState>)=>{window.clearTimeout(timeout);channel.port1.close();resolve(event.data);};
    worker.postMessage({type:'VERIFY'},[channel.port2]);
  });
}
